<div class="form-container">
    <div class="font-semibold heading text-xl ">Personal details</div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
      <button type="submit" pButton [disabled]="form.invalid" class="custom-upload-button  btn-primary mt-4">
        Next
        <i class="pi pi-arrow-right arrow-icon" style="margin-left: 8px;"></i></button>
    </form>
  </div>
  